"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ClipboardArrowUp: function() {
        return ClipboardArrowUp;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ClipboardArrowUp = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.79293 1.79289C8.30061 1.28521 8.98918 1 9.70715 1H14.2929C15.0109 1 15.6995 1.28521 16.2071 1.79289C16.5445 2.13022 16.7836 2.5474 16.9061 3H18C19.6569 3 21 4.34315 21 6V20C21 21.6569 19.6569 23 18 23H5.98331C4.33629 23 2.99725 21.6722 2.98342 20.0252L2.86583 6.0252C2.85183 4.35856 4.19902 3 5.86573 3H7.09401C7.2165 2.5474 7.45561 2.13022 7.79293 1.79289ZM7.00004 5H5.86573C5.31016 5 4.86109 5.45285 4.86576 6.0084L4.98335 20.0084C4.98796 20.5574 5.4343 21 5.98331 21H18C18.5523 21 19 20.5523 19 20V6C19 5.44772 18.5523 5 18 5H17V6C17 6.55228 16.5523 7 16 7H8.00004C7.44775 7 7.00004 6.55228 7.00004 6V5ZM14.7929 3.20711C14.6603 3.0745 14.4805 3 14.2929 3H9.70715C9.51961 3 9.33975 3.0745 9.20714 3.20711C9.07454 3.33972 9.00004 3.51957 9.00004 3.70711V4V5H15V4V3.70711C15 3.51957 14.9255 3.33972 14.7929 3.20711ZM11.2929 10.2929C11.6835 9.90237 12.3166 9.90237 12.7071 10.2929L14.7071 12.2929C15.0977 12.6834 15.0977 13.3166 14.7071 13.7071C14.3166 14.0976 13.6835 14.0976 13.2929 13.7071L13 13.4142V17C13 17.5523 12.5523 18 12 18C11.4478 18 11 17.5523 11 17V13.4142L10.7071 13.7071C10.3166 14.0976 9.68346 14.0976 9.29293 13.7071C8.90241 13.3166 8.90241 12.6834 9.29293 12.2929L11.2929 10.2929Z",
        fill: "currentColor"
    })
}), "ClipboardArrowUp");
const _default = ClipboardArrowUp;
